export default "__VITE_ASSET__c6286c73__"